// "use client";
// import React, { useEffect, useState } from "react";

// export default function GoogleCaptchaWrapper({ children }) {
//     const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
//     const [isScriptLoaded, setIsScriptLoaded] = useState(false);
//     const [scriptError, setScriptError] = useState(false);

//     useEffect(() => {
//         if (!recaptchaKey) {
//             console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined! reCAPTCHA will not be available.');
//             return;
//         }

//         const loadRecaptchaScript = () => {
//             // Check if script is already loaded
//             if (typeof window !== 'undefined' && window.grecaptcha) {
//                 console.log('reCAPTCHA script already loaded');
//                 setIsScriptLoaded(true);
//                 return;
//             }

//             // Check if script tag already exists
//             const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');
//             if (existingScript) {
//                 console.log('reCAPTCHA script tag already exists, waiting for load...');
//                 // Wait for the existing script to load
//                 const checkLoaded = () => {
//                     if (window.grecaptcha) {
//                         setIsScriptLoaded(true);
//                     } else {
//                         setTimeout(checkLoaded, 100);
//                     }
//                 };
//                 checkLoaded();
//                 return;
//             }

//             console.log('Loading reCAPTCHA v2 script...');
//             const script = document.createElement('script');
//             script.src = 'https://www.google.com/recaptcha/api.js';
//             script.async = true;
//             script.defer = true;
//             script.onload = () => {
//                 console.log('reCAPTCHA v2 script loaded successfully');
//                 setIsScriptLoaded(true);
//                 setScriptError(false);
//             };
//             script.onerror = () => {
//                 console.error('Failed to load reCAPTCHA script');
//                 setScriptError(true);
//             };
//             document.head.appendChild(script);
//         };

//         // Load script with a small delay to ensure DOM is ready
//         const timer = setTimeout(loadRecaptchaScript, 100);
//         return () => clearTimeout(timer);
//     }, [recaptchaKey]);

//     // Cleanup function to reset state when component unmounts
//     useEffect(() => {
//         return () => {
//             setIsScriptLoaded(false);
//             setScriptError(false);
//         };
//     }, []);
    
//     if (!recaptchaKey) {
//         console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined! reCAPTCHA will not be available.');
//         return <>{children}</>;
//     }

//     if (scriptError) {
//         console.error('reCAPTCHA script failed to load, rendering without reCAPTCHA');
//         return <>{children}</>;
//     }

//     // Always render children, let individual components handle their own loading states
//     return <>{children}</>;
// }

"use client";
import React, { useEffect, useState } from "react";

export default function GoogleCaptchaWrapper({ children }) {
    const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const [scriptError, setScriptError] = useState(false);

    useEffect(() => {
        if (!recaptchaKey) {
            console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined! reCAPTCHA will not be available.');
            return;
        }

        const loadRecaptchaScript = () => {
            // Check if script is already loaded
            if (typeof window !== 'undefined' && window.grecaptcha) {
                console.log('reCAPTCHA v3 script already loaded');
                setIsScriptLoaded(true);
                return;
            }

            // Check if script tag already exists
            const existingScript = document.querySelector('script[src*="recaptcha/api.js"]');
            if (existingScript) {
                console.log('reCAPTCHA v3 script tag already exists, waiting for load...');
                // Wait for the existing script to load
                const checkLoaded = () => {
                    if (window.grecaptcha) {
                        setIsScriptLoaded(true);
                    } else {
                        setTimeout(checkLoaded, 100);
                    }
                };
                checkLoaded();
                return;
            }

            console.log('Loading reCAPTCHA v3 script (invisible)...');
            const script = document.createElement('script');
            // render=<sitekey> loads the invisible v3 client — no checkbox/widget markup needed.
            script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                console.log('reCAPTCHA v3 script loaded successfully');
                setIsScriptLoaded(true);
                setScriptError(false);
            };
            script.onerror = () => {
                console.error('Failed to load reCAPTCHA script');
                setScriptError(true);
            };
            document.head.appendChild(script);
        };

        // Load script with a small delay to ensure DOM is ready
        const timer = setTimeout(loadRecaptchaScript, 100);
        return () => clearTimeout(timer);
    }, [recaptchaKey]);

    // Cleanup function to reset state when component unmounts
    useEffect(() => {
        return () => {
            setIsScriptLoaded(false);
            setScriptError(false);
        };
    }, []);

    if (!recaptchaKey) {
        console.warn('NEXT_PUBLIC_RECAPTCHA_SITE_KEY is not defined! reCAPTCHA will not be available.');
        return <>{children}</>;
    }

    if (scriptError) {
        console.error('reCAPTCHA script failed to load, rendering without reCAPTCHA');
        return <>{children}</>;
    }

    // Always render children, let individual components handle their own loading states
    return <>{children}</>;
}